<template>
  <div>
    <v-range-slider
      :model-value="modelValue"
      data-test="childAgeRange-slider"
      class="mr-9"
      min="0"
      max="35"
      step="1"
      density="compact"
      hide-details
      @update:model-value="$emit('update:modelValue', $event)"
    />
    <div
      class="age-slider-caption"
      data-test="childAgeRange-caption"
    >
      {{ label }}
    </div>
  </div>
</template>

<script>
import { childAgeMonthLabel } from "../utils/childAge";

/**
 * 子どもの月齢範囲スライダー（FSD shared/ui）
 *
 * v-model でスライダー値（[0, 35]）を受け取り、
 * 月齢ラベルを表示する汎用コンポーネント。
 *
 * 使用例:
 *   <ChildAgeRangeSlider v-model="sliderValue" />
 *
 * スライダー値→月齢の変換ロジックは shared/utils/childAge.js に集約している。
 */
export default {
  name: "ChildAgeRangeSlider",

  props: {
    modelValue: {
      type: Array,
      default: () => [0, 35]
    }
  },

  emits: ["update:modelValue"],

  computed: {
    label() {
      return (
        childAgeMonthLabel(this.modelValue[0]) +
        " 〜 " +
        childAgeMonthLabel(this.modelValue[1], true)
      );
    }
  }
};
</script>
